#import "../../../graphql/fragments/edition-fragment.graphql"

query GetDripSequenceEditions(
    $limit: Int!
    $cursor: String
    $dripSequenceId: ID!
    $isArchived: Boolean
) {
    dripSequence(id: $dripSequenceId) {
        id
        editions(first: $limit, after: $cursor, archived: $isArchived) {
            edges {
                cursor
                node {
                    ...EditionFragment
                }
            }
        }
    }
}
